import { useCallback } from "react";
import { IFundOrderTableSearchParams, IManualTablesSearchParam } from "../../Interfaces/manualInterfaces";
import OrderTableFilters from "../shared/OrderTableFilters";
import {
  getManualFundOrderFilterOptions,
  getManualOrderFilterOptions,
  getManualTradeFilterOptions,
  getManualErrorFilterOptions,
  getManualFailedOrderFilterOptions,
} from "../../Requests/manualRequests";

export type ManualFilterMode = "fund" | "order" | "trade" | "errors" | "failedOrders";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: IManualTablesSearchParam;
  mode: ManualFilterMode;
  fundSearchParam: IFundOrderTableSearchParams;
  onFundChange: (name: string, value: any) => void;
}

const getFilterOptionsByMode: Record<
  Exclude<ManualFilterMode, "fund">,
  typeof getManualOrderFilterOptions
> = {
  order: getManualOrderFilterOptions,
  trade: getManualTradeFilterOptions,
  errors: getManualErrorFilterOptions,
  failedOrders: getManualFailedOrderFilterOptions,
};

const SearchParamBox = ({ onChange, searchParam, mode, fundSearchParam, onFundChange }: IProps) => {
  const getFilterOptions = useCallback(
    () => mode === "fund" ? getManualFundOrderFilterOptions(fundSearchParam) : getFilterOptionsByMode[mode](searchParam),
    [mode, searchParam, fundSearchParam],
  );
  return (
    <OrderTableFilters
      getFilterOptions={getFilterOptions}
      searchParam={mode === "fund" ? fundSearchParam : searchParam}
      accountField="sahraUserId"
      onChange={mode === "fund" ? onFundChange : onChange}
      instrumentLabel={mode === "fund" ? "نماد صندوق" : "نماد"}
    />
  );
};

export default SearchParamBox;
